<template>
  <div class="disposal-statistics-container">
    <!-- 标题区域 -->
    <div class="header-section">
      <div class="title">西药房门诊退药</div>
      <div class="sub-title"></div>
    </div>
 
    <!-- 筛选区域 -->
    <el-card class="filter-section">
      <div class="filter-container">
        <div class="filter-left">
          <!-- 状态筛选下拉菜单 -->
          <div class="filter-item">
            <el-dropdown trigger="hover" placement="bottom-start" @command="handleStateCommand">
              <el-button type="primary" size="mini" class="state-dropdown-btn">
                {{ getStateButtonText() }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="''">全部</el-dropdown-item>
                <el-dropdown-item :command="0">草稿</el-dropdown-item>
                <el-dropdown-item :command="1">已收费</el-dropdown-item>
                <el-dropdown-item :command="2">已配药</el-dropdown-item>
                <el-dropdown-item :command="3">已发药</el-dropdown-item>
                <el-dropdown-item :command="4">待退费</el-dropdown-item>
                <el-dropdown-item :command="5">已退药</el-dropdown-item>
                <el-dropdown-item :command="6">已作废</el-dropdown-item>
                <el-dropdown-item :command="7">已退费</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          
          <div class="filter-item">
            <span class="filter-label">处方编号：</span>
            <el-input
              v-model="filters.rxNo"
              placeholder="处方编号/病人姓名"
              size="mini"
              clearable
              style="width: 160px;"
              @keyup.enter.native="handleSearch"
            />
          </div>
          
          <div class="filter-item">
            <span class="filter-label">时间范围：</span>
            <el-date-picker
              v-model="filters.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              style="width: 220px;"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              class="custom-date-picker"
            />
          </div>
		  
		  <div class="filter-right">
		    <el-button type="primary" size="mini" @click="handleSearch" icon="el-icon-Ssearch">查询</el-button>
		    <el-button type="warning" size="mini" @click="handleReset" icon="el-icon-refresh">重置</el-button>
		    <el-button type="success" size="mini" :disabled="true" @click="handleExport" icon="el-icon-download">导出</el-button>
		  </div>
        </div>
      </div>
    </el-card>
 
    <!-- 表格区域 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          :height="tableMaxHeight"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          v-loading="loading"
          :row-class-name="tableRowClassName"
        >
          <!-- 行号 -->
          <el-table-column
            label="#"
            type="index"
            align="center"
            width="60"
            fixed="left"
          />
          
          <!-- 处方状态 -->
          <el-table-column
            prop="state"
            label="处方状态"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag
                :type="getStatusType(scope.row.state)"
                size="small"
                effect="plain"
              >
                {{ getStatusText(scope.row.state) }}
              </el-tag>
            </template>
          </el-table-column>
          
		  <!-- 处方编号 -->
		  <el-table-column
		    prop="rxNo"
		    label="处方编号"
		    align="left"
		    width="140"
		    show-overflow-tooltip
		  >
		    <template slot-scope="scope">
		      <a 
		        href="javascript:void(0)" 
		        class="patient-name-link" 
		        @click="handleViewDetail(scope.row)"
		      >
		        <strong>{{ scope.row.rxNo }}</strong>
		      </a>
		    </template>
		  </el-table-column>
		  
          <!-- 病人姓名 -->
          <el-table-column
            prop="name"
            label="病人姓名"
            align="left"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          
          <!-- 性别 -->
          <el-table-column
            prop="sex"
            label="性别"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              <div class="gender-display">
                <i :class="scope.row.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="scope.row.sex === 1 ? 'male-text' : 'female-text'">
                  {{ scope.row.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </template>
          </el-table-column>
          
          <!-- 年龄 -->
          <el-table-column
            prop="age"
            label="年龄"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.age }}岁
            </template>
          </el-table-column>
          
          <!-- 划价方式 -->
          <el-table-column
            prop="pricingType"
            label="划价方式"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ getPricingTypeText(scope.row.pricingType) }}
            </template>
          </el-table-column>
          
          <!-- 皮试处方 -->
          <el-table-column
            prop="skintstRx"
            label="皮试处方"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.skintstRx === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          
          <!-- 处方类型 -->
          <el-table-column
            prop="rxName"
            label="处方类型"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 处方科室 -->
          <el-table-column
            prop="bilgDeptId"
            label="处方科室"
            align="center"
            width="120"
            show-overflow-tooltip
          />
          
          <!-- 处方医生 -->
          <el-table-column
            prop="bilgDrId"
            label="处方医生"
            align="center"
            width="120"
            show-overflow-tooltip
          />
          
          <!-- 处方金额 -->
          <el-table-column
            prop="saleAmt"
            label="处方金额(元)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.saleAmt) }}
            </template>
          </el-table-column>
          
          <!-- 划价人 -->
          <el-table-column
            prop="bilgOptId"
            label="划价人"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 划价时间 -->
          <el-table-column
            prop="bilgDate"
            label="划价时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.bilgDate) }}
            </template>
          </el-table-column>
          
          <!-- 退药人 -->
          <el-table-column
            prop="dismedOptId"
            label="退药人"
            align="center"
            width="100"
            show-overflow-tooltip
          />
          
          <!-- 退药时间 -->
          <el-table-column
            prop="dismedOptDate"
            label="退药时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.dismedOptDate) }}
            </template>
          </el-table-column>
          
          <!-- 收款时间 -->
          <el-table-column
            prop="costDate"
            label="收款时间"
            align="center"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.costDate) }}
            </template>
          </el-table-column>
          
          <!-- 退药金额 -->
          <el-table-column
            prop="reAmt"
            label="退药金额(元)"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ formatCurrency(scope.row.reAmt) }}
            </template>
          </el-table-column>
          
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <div class="action-buttons">
                <!-- 处方详情按钮 - 所有状态都显示 -->
                <el-button 
                  type="primary" 
                  size="mini" 
                  @click="handleViewDetail(scope.row)"
                  plain
                >
                  详情
                </el-button>
                
                <!-- 退药按钮 - 只在state=3(已退药)时启用，否则禁用 -->
                <template>
                  <el-button 
                    type="warning" 
                    size="mini" 
                    icon="el-icon-export"
                    @click="handleRefund(scope.row)"
                    plain
                  >
                    退药
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="pagination-container left-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            small
          />
        </div>
      </div>
    </div>
    
    <!-- 处方详情模态框 -->
    <el-dialog 
      :title="currentDetail.name + ' ' + currentDetail.rxNo + ' 的处方详情'" 
      :visible.sync="detailDialogVisible" 
      width="80%" 
      top="5vh"
      custom-class="custom-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="detail-content">
        <!-- 顶部信息区域 -->
        <div class="detail-info">
          <el-descriptions :column="4" size="small" border>
            <el-descriptions-item label="患者姓名">
              <el-tag size="small">{{ currentDetail.name || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <div class="gender-display">
                <i :class="currentDetail.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="currentDetail.sex === 1 ? 'male-text' : 'female-text'">
                  {{ currentDetail.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ (currentDetail.age || 0) + '岁' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类别">
              <el-tag size="small">{{ currentDetail.rxName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方状态">
              <el-tag
                :type="getStatusType(currentDetail.state)"
                size="small"
              >
                {{ getStatusText(currentDetail.state) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">{{ formatCurrency(currentDetail.saleAmt) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ currentDetail.bilgDeptId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ currentDetail.bilgDrId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="划价方式">
              <span>{{ getPricingTypeText(currentDetail.pricingType) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="皮试处方">
              <span>{{ currentDetail.skintstRx === 1 ? '是' : '否' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="划价人">
              <span>{{ currentDetail.bilgOptId || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="划价时间">
              <span>{{ formatDateTime(currentDetail.bilgDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="退药人">
              <span>{{ currentDetail.dismedOptId || '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="退药时间">
              <span>{{ formatDateTime(currentDetail.dismedOptDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="收款时间">
              <span>{{ formatDateTime(currentDetail.costDate) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="已退金额">
              <span>{{ formatCurrency(currentDetail.saleAmt) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="退药标识">
              <el-tag :type="currentDetail.retFlag === 1 ? 'danger' : 'info'" size="small">
                {{ currentDetail.retFlag === 1 ? '已退药' : '未退药' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>
 
        <!-- 处方药品明细表格区域 -->
        <div class="detail-table-container" v-if="detailDrugList.length > 0">
          <div class="table-title">处方药品明细</div>
          <el-table :data="detailDrugList" border highlight-current-row class="detail-table">
            <el-table-column label="序号" fixed="left" type="index" width="60" align="center"></el-table-column>
			
			<!-- 操作列 、 生产批次号 -->
			<el-table-column 
			  label="生产批次号" 
			  width="120"
			  fixed="left"
			  align="left"
			>
			  <template slot-scope="{ row, $index }">
			    <div class="action-column">
			      <span > {{ (row.manuLotnum) }}</span>
			    </div>
			  </template>
			</el-table-column>
            <el-table-column prop="drugName" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="drugSpec" label="规格" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cnt" label="数量" width="80" align="center"></el-table-column>
            <el-table-column prop="unt" label="单位" width="80" align="center"></el-table-column>
            <el-table-column prop="salePric" label="单价" width="100" align="right">
              <template slot-scope="{ row }">
                <span>{{ formatCurrency(row.salePric) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="saleAmt" label="金额" width="100" align="right">
              <template slot-scope="{ row }">
                <span>{{ formatCurrency(row.saleAmt) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="usage" label="用法" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="usedFrquId" label="频次" width="80" align="center"></el-table-column>
            <el-table-column prop="prdCnt" label="周期次数" width="100" align="center"></el-table-column>
            <el-table-column prop="prdDays" label="周期天数" width="80" align="center"></el-table-column>
            <el-table-column prop="prodentpName" label="生产厂家" width="150" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        
        <!-- 无药品明细提示 -->
        <div class="no-data" v-else>
          <el-empty description="暂无药品明细数据"></el-empty>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 退药模态框 -->
    <el-dialog 
      :title="addForm.name + ' ' + addForm.rxNo + ' 的处方退药'" 
      :visible.sync="refundDialogVisible" 
      width="80%" 
      top="5vh"
      custom-class="custom-dialog refund-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="refund-content">
        <!-- 顶部信息区域 -->
        <div class="refund-info">
          <el-descriptions 
            :column="4" 
            size="small" 
            border
            :title="'药房:' + addForm.bilgDeptName"
          >
            <template slot="title">
              <div class="title-with-select">
                <div class="refund-reason-select">
                  <span class="reason-label">退药原因：</span>
                  <el-select 
                    v-model="addForm.refundReason" 
                    placeholder="请选择退药原因" 
                    size="mini"
                    filterable 
                    allow-create 
                    clearable 
                    class="reason-select"
                  >
                    <el-option v-for="item in refundReasons" :key="item.id" :label="item.value" :value="item.value"></el-option>
                  </el-select>
                </div>
				<div class="refund-reason-select" style="margin-left: 12px;">
				  <span class="reason-label">备注说明：</span>
				  <el-input
				    type="textarea" 
				    :rows="1" 
					maxlength="10"
				    v-model="addForm.remark" 
				    placeholder="请输入备注"
				    size="mini" 
				  ></el-input>
				</div>
              </div>
            </template>
            
            <el-descriptions-item label="患者姓名">
              <el-tag size="small">{{ addForm.name || '古老板' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <div class="gender-display">
                <i :class="addForm.sex === 1 ? 'el-icon-male male-icon' : 'el-icon-female female-icon'"></i>
                <span :class="addForm.sex === 1 ? 'male-text' : 'female-text'">
                  {{ addForm.sex === 1 ? '男' : '女' }}
                </span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ addForm.age + '岁' || '28岁' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方编号">
              <el-tag size="small">{{ addForm.rxNo || 'JZ000000001' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类别">
              <el-tag size="small">{{ addForm.rxName || '急诊' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">{{ formatCurrency(addForm.saleAmt) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ addForm.bilgDeptName || '九阵门诊' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ addForm.patientName || '九阵管理员' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="划价方式">
              <span>{{ pricingTypeMap[addForm.pricingType] || '' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="处方诊断">
              <el-tag size="small">{{ addForm.westernDiagnos || '九阵管理员' }}</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>
 
        <!-- 处方退药明细表区域 -->
        <div class="refund-detail-container">
          <div class="refund-detail-content">
            <!-- 左侧药品列表 -->
            <div class="left-drug-list">
              <div class="drug-list-header">
                <span class="drug-list-title">处方退药明细表</span>
                <el-button 
                  type="danger" 
                  size="mini" 
                  plain 
                  @click="refundAll"
                  :loading="loading"
                  class="refund-all-btn"
                >
                  全退
                </el-button>
              </div>
              <div class="drug-list-content">
                <div 
                  v-for="(item, index) in leftDrugList" 
                  :key="index"
                  class="drug-list-item"
                  @dblclick="addToRightTable(item)"
                  :class="{ 'selected': isItemInRightTable(item) }"
                >
                  <div class="drug-avatar">
                    {{ getFirstChar(item.drugName) }}
                  </div>
                  <div class="drug-info">
                    <div class="drug-name">{{ item.drugName | truncate(8) }}</div>
                    <div class="drug-spec" v-if="item.drugSpec" :title="item.drugSpec">
                      {{ item.drugSpec | truncate(6) }}
                    </div>
                  </div>
                  <div class="drug-right-info">
                    <div class="drug-cnt">{{ item.cnt }}{{ item.unt }}</div>
                    <div class="drug-amount">{{ formatCurrencyWithSeparator(item.saleAmt) }}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 右侧退药明细表 -->
            <div class="right-refund-table">
              <div class="table-header">退药明细</div>
              <div class="table-container">
                <el-table 
                  :data="rightTableData" 
                  border 
                  highlight-current-row 
                  class="refund-detail-table"
                  size="mini"
                >
                  <el-table-column 
                    label="药品名称" 
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.drugName }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    prop="drugSpec" 
                    label="药品规格" 
                    width="140"
                  >
                    <template slot-scope="{ row }">
                      <el-tooltip 
                        :content="row.drugSpec || '无规格'" 
                        placement="top"
                        v-if="row.drugSpec && row.drugSpec.length > 8"
                      >
                        <span>{{ row.drugSpec | truncate(8) }}</span>
                      </el-tooltip>
                      <span v-else>{{ row.drugSpec || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="待退数" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row, $index }">
                      <!-- 编辑状态：显示输入框 -->
                      <el-input 
                        v-if="row.editing"
                        v-model.number="row.tempRetnCnt" 
                        size="mini"
                        @input="handleRetnCntInput(row, $index)"
                        class="retn-cnt-input"
                        placeholder="请输入"
                        :max="row.cnt"
                        :min="1"
                      ></el-input>
                      <!-- 锁定状态：显示文本 -->
                      <span v-else>
                        {{ row.retnCnt || 0 }}
                      </span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="已退数量" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.returnedCnt || 0 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    label="处方数量" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.cnt }}{{ row.unt }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="处方药单位" 
                    width="120"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span v-if="row.purcType == 1">最小单位（{{ row.unt }}）</span>
                      <span v-else-if="row.purcType == 2">包装单位（{{ row.unt }}）</span>
                      <span v-else>（{{ row.unt }}）</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="药售单价" 
                    width="100"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ formatCurrencyWithSeparator(row.salePric) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="药售总价" 
                    width="100"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ formatCurrencyWithSeparator(row.saleAmt) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="批次号" 
                    width="100"
                    align="center"
					show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.manuLotnum || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="生产厂家" 
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.prodentpName || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <!-- 新增字段开始 -->
                  <el-table-column 
                    label="周期天数" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.prdDays || 0 }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="周期次数" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.prdCnt || 0 }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="指定售价" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <el-tag 
                        size="mini" 
                        :type="row.isFixPrice === 1 ? 'success' : 'info'"
                      >
                        {{ row.isFixPrice === 1 ? '是' : '否' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="已退金额" 
                    width="100"
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ formatCurrencyWithSeparator(row.returnedAmt || 0) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="取整方式" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span v-if="row.roundUnt === 1">单次取整</span>
                      <span v-else-if="row.roundUnt === 2">总量取整</span>
                      <span v-else-if="row.roundUnt === 3">处方取整</span>
                      <span v-else-if="row.roundUnt === 4">不取整</span>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="单次剂量" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.sdoseCnt || 0 }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="总剂量" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ calculateTotalDose(row) }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="剂量单位" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.sdoseUnt || '-' }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="是否皮试" 
                    width="80"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <el-tag 
                        size="mini" 
                        :type="row.skintstDicm === 1 ? 'danger' : 'info'"
                      >
                        {{ row.skintstDicm === 1 ? '是' : '否' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  
                  <el-table-column 
                    label="用药频率" 
                    width="100"
                    align="center"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.usedFrquId || '-' }}</span>
                    </template>
                  </el-table-column>
                  <!-- 新增字段结束 -->
                  
                  <!-- 操作列 -->
                  <el-table-column 
                    label="操作" 
                    width="200"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="{ row, $index }">
                      <div class="action-column">
                        <!-- 差异数显示 -->
                        <el-tooltip 
                          :content="'差异金额: ' + formatCurrencyWithSeparator(row.diffAmount)" 
                          placement="top"
                          v-if="row.diffAmount !== null && row.diffAmount !== undefined && Math.abs(row.diffAmount).toString().length > 8"
                        >
                          <span 
                            class="diff-amount"
                            :class="{ 
                              'negative': row.diffAmount < 0,
                              'positive': row.diffAmount >= 0
                            }"
                          >
                            差异: {{ formatTruncatedNumber(row.diffAmount) }}
                          </span>
                        </el-tooltip>
                        <span 
                          v-else
                          class="diff-amount"
                          :class="{ 
                            'negative': row.diffAmount < 0,
                            'positive': row.diffAmount >= 0
                          }"
                        >
                          差异: {{ formatCurrencyWithSeparator(row.diffAmount) }}
                        </span>
                        
                        <!-- 修改按钮 -->
                        <el-button 
                          v-if="!row.editing && row.retnCnt > 0"
                          type="text" 
                          size="mini"
                          @click="editItem(row, $index)"
                        >
                          修改
                        </el-button>
                        
                        <!-- 追溯码按钮（仅在isBar===1时显示） -->
                        <el-button
                          v-if="row.isBar === 1"
                          type="primary"
                          size="mini"
                          @click="openTraceCodeTransfer(row, $index)"
                          class="trace-code-btn"
                        >
                          {{ row.traceCodeCollected ? `追溯码(${getSelectedTraceCount(row)})` : '追溯码' }}
                        </el-button>
                        
                        <!-- 移除按钮 -->
                        <el-button 
                          type="text" 
                          size="mini"
                          @click="removeItem($index)"
                          style="color: #F56C6C;"
                        >
                          移除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <!-- 底部固定操作区域 -->
      <div class="refund-footer-fixed">
        <div class="footer-left-info">
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">处方总额：</span>
              <span class="info-value-money">{{ formatCurrencyWithSeparator(prescriptionDetail.saleAmt || 0) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">处方药：</span>
              <span class="info-value">{{ leftDrugList.length }}种</span>
            </div>
            <div class="info-item">
              <span class="info-label">当前待退处方：</span>
              <span class="info-value">{{ rightTableData.length }}种</span>
            </div>
            <div class="info-item">
              <span class="info-label">当前待退处方总额：</span>
              <span class="info-value-money">{{ formatCurrencyWithSeparator(refundTotalAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="refund-actions">
          <el-tooltip
            placement="top"
            :disabled="!hasUncollectedTraceCode || isConfirmButtonEnabled"
            content="当前处方退药明细列表中有需要进行追溯码录入上传的药品，请先去进行追溯码录入！"
          >
            <el-button 
              :loading="loading" 
              type="primary" 
              size="small" 
              plain 
              @click="handleBatchRefund"
              :disabled="!isConfirmButtonEnabled" 
              class="footer-btn"
            >
              确认退药
            </el-button>
          </el-tooltip>
          <el-button size="small" @click="refundDialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
	
	<!-- 追溯码穿梭框模态框 -->
	<el-dialog
	  :title="'追溯码选择 - ' + (currentTraceCodeRow ? currentTraceCodeRow.drugName : '')"
	  :visible.sync="traceCodeTransferVisible"
	  width="800px"
	  top="10vh"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  class="trace-code-transfer-dialog"
	>
	  <div class="transfer-container">
		<el-transfer
		  v-model="selectedTraceCodes"
		  :data="availableTraceCodes"
		  :titles="['发药已采集追溯码', '退药采集追溯码']"
		  :button-texts="['移除', '选择']"
		  filterable
		  filter-placeholder="搜索追溯码"
		  @change="handleTransferChange"
		>
		  <span slot-scope="{ option }">
			{{ option.label }} (数量: {{ option.chgCnt }})
		  </span>
		</el-transfer>
	  </div>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="traceCodeTransferVisible = false">取消</el-button>
		<el-button type="primary" @click="confirmTraceCodeSelection" :disabled="selectedTraceCodes.length === 0">完成</el-button>
	  </span>
	</el-dialog>
 
	<!-- 步骤进度条模态框 -->
	<el-dialog
	  title="追溯码上传进度"
	  :visible.sync="traceCodeUploadDialog"
	  width="700px"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  class="trace-code-upload-dialog"
	>
	  <div class="upload-progress-dialog">
		<!-- 步骤条 -->
		<el-steps 
		  :active="traceCodeUploadStep" 
		  align-center
		  finish-status="success"
		  class="upload-steps"
		>
		  <el-step
			v-for="(step, index) in traceCodeUploadSteps"
			:key="index"
			:title="step.title"
			:description="step.description"
			:status="getStepStatus(index)"
		  />
		</el-steps>
		
		<!-- 进度详情 -->
		<div class="upload-details">
		  <div class="details-title">上传详情：</div>
		  <div 
			class="details-content" 
			ref="uploadDetailsContainer"
			style="max-height: 200px; overflow-y: auto;"
		  >
			<div 
			  v-for="(detail, index) in traceCodeUploadDetails" 
			  :key="index"
			  class="detail-item"
			  :class="detail.type"
			>
			  <i :class="getDetailIcon(detail.type)"></i>
			  <span>{{ detail.message }}</span>
			  <span class="detail-time">{{ detail.time }}</span>
			</div>
		  </div>
		</div>
		
		<!-- 进度条 -->
		<div v-if="traceCodeUploadStep < traceCodeUploadSteps.length" class="upload-progress">
		  <el-progress
			:percentage="uploadProgress"
			:status="uploadStatus"
			:show-text="false"
		  />
		</div>
	  </div>
	  
	  <template slot="footer" class="upload-dialog-footer">
		<div v-if="showRetryButton && traceCodeHasError">
		  <el-button @click="closeTraceCodeUploadDialog" type="primary">我已知晓</el-button>
		</div>
		<div v-else-if="traceCodeUploadStep === 5 && !traceCodeHasError && msfxUploadSuccess">
		  <!-- 自动关闭 -->
		</div>
		<div v-else-if="traceCodeUploadStep === 5 && !traceCodeHasError && !msfxUploadSuccess">
		  <el-button @click="closeTraceCodeUploadDialog" type="primary">我已知晓</el-button>
		</div>
		<div v-else>
		  <el-button @click="handleUploadCancel">取消</el-button>
		</div>
	  </template>
	</el-dialog>
	
	<!-- 确认最小单位追溯码数量模态框 -->
	<el-dialog
	  title="确认最小单位（小包装）的追溯码数量"
	  :visible.sync="traceCodeQuantityDialogVisible"
	  width="500px"
	  top="20vh"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	>
	  <el-table :data="tempTraceCodeQuantities" border size="mini">
	    <el-table-column label="追溯码" prop="barcode" width="250"></el-table-column>
	    <el-table-column label="数量（小单位）" width="150">
	      <template slot-scope="{ row, $index }">
	        <el-input-number
	          v-model="row.quantity"
	          :min="0"
	          :max="row.max"
	          :precision="0"
	          size="mini"
	          controls-position="right"
	          style="width: 130px;"
	        ></el-input-number>
	      </template>
	    </el-table-column>
	  </el-table>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="traceCodeQuantityDialogVisible = false">取消</el-button>
	    <el-button type="primary" @click="confirmTraceCodeQuantity">确认数量</el-button>
	  </span>
	</el-dialog>
	
  </div>
</template>
 
<script>
import { rxmainPage, getRefundDrug, tySave } from "@/api/MedicenHouse/WesternGive.js"
import { 
  msfxCodeDetail, 
  msfxGetEntInfoList, 
  msfListUpoutDetail, 
  msfxUploadInoutBill, 
  msfxUploadRetail,
  getSomeWare,
  getCJSomeWare
} from "@/api/systemCatalogue/Western.js";
import { getSystemList } from "@/api/systemParameter/systemParameter"

export default {
  name: 'DisposalStatistics',
  filters: {
    truncate(value, length) {
      if (!value) return ''
      if (value.length <= length) return value
      return value.substring(0, length) + '...'
    }
  },
  computed: {
    // 保留原有计算属性（可能不再使用，但避免报错）
    validTraceCodeCount() {
      return this.scannedMedicineList.filter(item => 
        item.traceCode && item.traceCode.trim() !== '' && item.validationStatus === 'success'
      ).length;
    },
    hasUnvalidatedTraceCodes() {
      return this.scannedMedicineList.some(item => 
        item.traceCode && item.traceCode.trim() !== '' && item.validationStatus !== 'success' && item.validationStatus !== 'warning'
      );
    },
    isAddTraceCodeDisabled() {
      return this.isFirstOpenTraceCodeDialog && this.scannedMedicineList.length === 0;
    },
    uploadProgress() {
      const totalSteps = this.traceCodeUploadSteps.length;
      return Math.floor((this.traceCodeUploadStep / totalSteps) * 100);
    },
    uploadStatus() {
      if (this.traceCodeHasError) return 'exception';
      return 'success';
    }
  },
  
  data() {
    return {
      // 筛选条件
      filters: {
        rxNo: '',
        filterState: '',
        dateRange: []
      },
      // 表格数据
      tableData: [],
      loading: false,
      
      // 分页
      pageNum: 1,
      pageSize: 20,
      total: 0,
      
      // 表格最大高度
      tableMaxHeight: 'calc(100vh - 280px)',
      
      // 详情模态框相关
      detailDialogVisible: false,
      currentDetail: {},
      detailDrugList: [],
      
      // 退药模态框相关
      refundDialogVisible: false,
      leftDrugList: [],
      rightTableData: [],
      refundTotalAmount: 0,
      isConfirmButtonEnabled: false,
      
      prescriptionDetail: {},
      
      // 追溯码相关（保留部分原有字段避免报错，但不再使用扫描功能）
      traceCodeDialogTitle: '追溯码录入采集与上传',
      traceCodeDialogVisible: false,
      traceCodeLoading: false,
      getSomeWareLoading: false,
      scannedMedicineList: [],
      getSomeWareResult: null,
      scanInput: '',
      currentTraceCodeItem: null,
      currentTraceCodeIndex: -1,
      isFirstOpenTraceCodeDialog: true,
      duplicateTraceCodes: [],
      hasUncollectedTraceCode: false,
      currentScannedTraceCode: '',
      traceCodeDetailResult: null,

      // 新增：穿梭框相关
      traceCodeTransferVisible: false,
      currentTraceCodeRow: null,
      currentTraceCodeIndexForTransfer: -1,
      availableTraceCodes: [],
      selectedTraceCodes: [],
	  // 新增：数量确认模态框
	  traceCodeQuantityDialogVisible: false,
	  tempTraceCodeQuantities: [], // [{ barcode: '', quantity: number, max: number }]
      // 步骤进度条相关
      traceCodeUploadDialog: false,
      traceCodeUploadStep: 0,
      traceCodeUploadSteps: [
        { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...' },
        { title: '接入码上放心', description: '正在接入码上放心平台接口...' },
        { title: '上传追溯码', description: '正在上传退药明细追溯码数据...' },
        { title: '完成上传', description: '追溯码退药已上传至码上放心平台。' },
        { title: '完成退药', description: '已完成退药。' }
      ],
      traceCodeUploadDetails: [],
      traceCodeHasError: false,
      showRetryButton: false,
      uploadRetryCount: 0,
      msfxUploading: false,
      autoCloseTimer: null,
      msfxUploadError: '',
      msfxUploadSuccess: true,

      // 退药表单
      addForm: {
        age: 0,
        bilgDeptId: 0,
        bilgDeptName: '',
        id: 0,
        name: '',
        phayId: 0,
        pricingType: 0,
        remark: '',
        rxName: '',
        rxNo: 0,
        saleAmt: 0,
        sex: 0,
        refundReason: '',
        westernDiagnos: '',
        patientName: '',
        refundList: []
      },
      
      // 退药原因选项
      refundReasons: [
        { value: '患者过敏', id: 1 },
        { value: '药品不良反应', id: 2 },
        { value: '医生更改处方', id: 3 },
        { value: '患者病情变化', id: 4 },
        { value: '药品质量问题', id: 5 },
        { value: '患者拒绝用药', id: 6 },
        { value: '用药剂量错误', id: 7 },
        { value: '药品过期', id: 8 },
        { value: '药品包装破损', id: 9 },
        { value: '其他原因', id: 10 }
      ],
      
      // 状态映射
      statusMap: {
        0: '草稿',
        1: '已收费',
        2: '已配药',
        3: '已发药',
        4: '待退费',
        5: '已退药',
        6: '已作废',
        7: '已退费'
      },
      
      // 划价方式映射
      pricingTypeMap: {
        1: '医嘱划价',
        2: '手工划价',
        3: '互联网划价',
      },
      
      // 状态标签类型
      statusTypeMap: {
        0: 'info',
        1: 'primary',
        2: 'primary',
        3: 'success',
        4: 'primary',
        5: 'warning',
        6: 'danger',
        7: 'warning'
      }
    }
  },
  mounted() {
    this.updateTableHeight();
    this.setDefaultDateRange();
    this.loadData();
    window.addEventListener('resize', this.updateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight)
  },
  methods: {
    // ===================== 基础方法 =====================
    updateTableHeight() {
      const headerHeight = 60
      const filterHeight = 80
      const paginationHeight = 60
      const padding = 40
      this.tableMaxHeight = `calc(100vh - ${headerHeight + filterHeight + paginationHeight + padding}px)`
    },
    
    setDefaultDateRange() {
      const now = new Date();
      const startDate = new Date(now);
      startDate.setHours(0, 0, 0, 0);
      const startDateStr = this.formatDate(startDate);
      const endDate = new Date(now);
      endDate.setHours(23, 59, 59, 999);
      const endDateStr = this.formatDate(endDate);
      this.filters.dateRange = [startDateStr, endDateStr];
    },
    
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '￥0'
      const num = Number(value)
      if (isNaN(num)) return '￥0'
      const parts = num.toString().split('.')
      let integerPart = parts[0]
      const decimalPart = parts.length > 1 ? '.' + parts[1] : ''
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return `￥${integerPart}${decimalPart}`
    },
    
    formatCurrencyWithSeparator(value) {
      return this.formatCurrency(value)
    },
    
    formatTruncatedNumber(value) {
      if (value === null || value === undefined || value === '') return '￥0'
      const num = Number(value)
      if (isNaN(num)) return '￥0'
      const formatted = this.formatCurrency(value)
      if (formatted.length <= 8) return formatted
      return formatted.substring(0, 8) + '...'
    },
    
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return dateTime
    },
    
    getStatusText(state) {
      return this.statusMap[state] || '未知状态'
    },
    
    getStatusType(state) {
      return this.statusTypeMap[state] || 'info'
    },
    
    getPricingTypeText(type) {
      return this.pricingTypeMap[type] || '未知'
    },
    
    getStateButtonText() {
      if (this.filters.filterState === '') return '全部'
      return this.getStatusText(this.filters.filterState)
    },
    
    getFirstChar(drugName) {
      if (!drugName || typeof drugName !== 'string') return '药'
      return drugName.charAt(0)
    },
    
    isItemInRightTable(item) {
      return this.rightTableData.some(rightItem => rightItem.id === item.id)
    },
    
    handleStateCommand(command) {
      this.filters.filterState = command
      this.handleSearch()
    },
    
    calculateTotalDose(row) {
      const sdoseCnt = Number(row.sdoseCnt) || 0
      const prdCnt = Number(row.prdCnt) || 0
      const prdDays = Number(row.prdDays) || 0
      return sdoseCnt * prdCnt * prdDays
    },
    
    // ===================== 数据加载 =====================
    async loadData() {
      try {
        this.loading = true
        const params = {
          condis: this.filters.rxNo,
          sendStartTime: this.filters.dateRange[0] || '',
          sendEndTime: this.filters.dateRange[1] || '',
          state: this.filters.filterState === '' ? '' : this.filters.filterState,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          bilgDrId: '',
          bilgDeptId: ''
        }
        const res = await rxmainPage(params)
        if (res.code === 200) {
          this.tableData = res.data.content || []
          this.total = res.data.totalSize || 0
        } else {
          this.$message.error(res.message || '获取数据失败')
          this.tableData = []
          this.total = 0
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pageNum = 1
      this.loadData()
    },
    
    handleReset() {
      this.filters = { rxNo: '', filterState: '', dateRange: [] }
      this.setDefaultDateRange()
      this.pageNum = 1
      this.pageSize = 20
      this.loadData()
    },
    
    handleExport() {
      this.$message.success('导出功能开发中')
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loadData()
    },
    
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    
    // ===================== 处方详情 =====================
    async handleViewDetail(row) {
      try {
        this.loading = true
        const res = await getRefundDrug({ id: row.id })
        if (res.code === 200) {
          this.currentDetail = res.data.prescription || row
          this.detailDrugList = res.data.refundList || []
          this.detailDialogVisible = true
        } else {
          this.$message.error(res.message || '获取处方详情失败')
        }
      } catch (error) {
        console.error('获取处方详情失败:', error)
        this.currentDetail = row
        this.detailDrugList = []
        this.detailDialogVisible = true
      } finally {
        this.loading = false
      }
    },
    
    tableRowClassName({ row }) {
      if (row.state === 3) return 'warning-row'
      return ''
    },
    
    // ===================== 退药操作 =====================
    async handleRefund(row) {
      try {
        this.loading = true
        this.leftDrugList = []
        this.rightTableData = []
        const res = await getRefundDrug({ id: row.id })
        if (res.code === 200) {
          this.prescriptionDetail = res.data
          // 左侧药品列表
          this.leftDrugList = (res.data.refundList || []).map(item => ({
            ...item,
            detailId: item.id,
            retnCnt: 0,
            retnAmt: 0,
            diffAmount: 0,
            purcType: item.purcType || 1,
            editing: false,
            tempRetnCnt: 0,
            isBar: item.isBar || 0,
            traceCode: item.traceCode || '',
            traceCodeCollected: false,
            // 新增：追溯码相关字段
            tracCodeJson: item.tracCodeJson || '',
            selectedTraceCodes: [],
            selectedTraceDetails: []
          }))
          this.addForm = { ...res.data }
          this.refundDialogVisible = true
        } else {
          this.$message.error(res.message || '获取退药详情失败')
        }
      } catch (error) {
        console.error('退药详情获取失败:', error)
        this.$message.error('获取退药详情失败')
      } finally {
        this.loading = false
      }
    },
    
    // ===================== 追溯码穿梭框 =====================
    getSelectedTraceCount(row) {
      return (row.selectedTraceCodes && row.selectedTraceCodes.length) || 0
    },
    
    openTraceCodeTransfer(row, index) {
      this.currentTraceCodeRow = row
      this.currentTraceCodeIndexForTransfer = index

      // 解析 tracCodeJson
      let traceCodeList = []
      if (row.tracCodeJson) {
        try {
          const parsed = JSON.parse(row.tracCodeJson)
          if (Array.isArray(parsed)) {
            traceCodeList = parsed
          }
        } catch (e) {
          console.error('解析tracCodeJson失败', e)
        }
      }

      // 构造穿梭框数据源
      this.availableTraceCodes = traceCodeList.map((item, idx) => ({
        key: item.barcode + '_' + idx,
        label: item.barcode,
        chgCnt: item.chgCnt
      }))

      // 恢复已选中的追溯码
      this.selectedTraceCodes = row.selectedTraceCodes || []

      this.traceCodeTransferVisible = true
    },
    
    handleTransferChange(value, direction, movedKeys) {
      // 可记录日志
    },
    
    confirmTraceCodeSelection() {
      const row = this.currentTraceCodeRow
      const index = this.currentTraceCodeIndexForTransfer
      if (!row || index === -1) return
    
      // 如果当前药品 saleUnt === 1，弹出数量输入模态框
      if (row.saleUnt === 1) {
        // 构建临时数量数组
        this.tempTraceCodeQuantities = this.selectedTraceCodes.map(key => {
          const found = this.availableTraceCodes.find(item => item.key === key)
          return {
            barcode: found ? found.label : '',
            quantity: found ? found.chgCnt : 1,
            max: row.pacCnt || 1
          }
        })
        this.traceCodeQuantityDialogVisible = true
        return
      }
    
      // saleUnt !== 1，直接保存（增加 manuLotnum）
      const selectedDetails = this.selectedTraceCodes.map(key => {
        const found = this.availableTraceCodes.find(item => item.key === key)
        if (found) {
          return {
            barcode: found.label,
            chgCnt: found.chgCnt,
            manuLotnum: row.manuLotnum || ''   // 新增生产批次号
          }
        }
        return null
      }).filter(item => item !== null)
    
      this.$set(this.rightTableData[index], 'selectedTraceCodes', [...this.selectedTraceCodes])
      this.$set(this.rightTableData[index], 'selectedTraceDetails', selectedDetails)
      this.$set(this.rightTableData[index], 'traceCodeCollected', this.selectedTraceCodes.length > 0)
    
      this.updateConfirmButtonState()
      this.traceCodeTransferVisible = false
      this.$message.success(`已选择 ${this.selectedTraceCodes.length} 个追溯码`)
    },
    
	// 追溯码相关,确认数量并保存
	confirmTraceCodeQuantity() {
	  // 验证数量合法性
	  for (let item of this.tempTraceCodeQuantities) {
	    const qty = Number(item.quantity)
	    if (isNaN(qty) || qty < 0 || qty > item.max) {
	      this.$message.error(`追溯码 ${item.barcode} 的数量必须在 0 到 ${item.max} 之间`)
	      return
	    }
	  }
	
	  const row = this.currentTraceCodeRow
	  const index = this.currentTraceCodeIndexForTransfer
	  if (!row || index === -1) return
	
	  // 构建 selectedTraceDetails，使用用户输入的数量，并增加 manuLotnum
	  const selectedDetails = this.tempTraceCodeQuantities.map(item => ({
	    barcode: item.barcode,
	    chgCnt: Number(item.quantity),
	    manuLotnum: row.manuLotnum || ''   // 新增生产批次号
	  }))
	
	  this.$set(this.rightTableData[index], 'selectedTraceCodes', [...this.selectedTraceCodes])
	  this.$set(this.rightTableData[index], 'selectedTraceDetails', selectedDetails)
	  this.$set(this.rightTableData[index], 'traceCodeCollected', this.selectedTraceCodes.length > 0)
	
	  this.updateConfirmButtonState()
	  this.traceCodeQuantityDialogVisible = false
	  this.traceCodeTransferVisible = false
	  this.$message.success(`已选择 ${this.selectedTraceCodes.length} 个追溯码`)
	},
	
    // ===================== 右侧表格操作 =====================
    addToRightTable(item) {
      if (this.isItemInRightTable(item)) {
        this.$message.warning('该药品已存在于退药明细中')
        return
      }
      const newItem = {
        ...item,
        id: item.id || item.detailId,
        retnCnt: 0,
        diffAmount: item.saleAmt || 0,
        editing: true,
        tempRetnCnt: 0,
        timer: null,
        isBar: item.isBar || 0,
        tracCodeJson: item.tracCodeJson || '',
        selectedTraceCodes: [],
        selectedTraceDetails: [],
        traceCodeCollected: false
      }
      this.rightTableData.push(newItem)
      this.calculateRefundTotal()
      this.updateConfirmButtonState()
    },
    
    refundAll() {
      if (this.leftDrugList.length === 0) {
        this.$message.warning('没有可退药的药品')
        return
      }
      this.rightTableData = []
      this.leftDrugList.forEach(item => {
        const newItem = {
          ...item,
          id: item.id || item.detailId,
          retnCnt: item.cnt || 0,
          diffAmount: 0,
          editing: false,
          tempRetnCnt: item.cnt || 0,
          timer: null,
          isBar: item.isBar || 0,
          tracCodeJson: item.tracCodeJson || '',
          selectedTraceCodes: [],
          selectedTraceDetails: [],
          traceCodeCollected: false
        }
        this.calculateDiffAmount(newItem)
        this.rightTableData.push(newItem)
      })
      this.calculateRefundTotal()
      this.updateConfirmButtonState()
      this.$message.success('已将所有药品添加到退药明细')
    },
    
    calculateDiffAmount(item) {
      const saleAmt = Number(item.saleAmt) || 0
      const salePric = Number(item.salePric) || 0
      const retnCnt = Number(item.retnCnt) || 0
      item.diffAmount = saleAmt - (retnCnt * salePric)
      return item.diffAmount
    },
    
    handleRetnCntInput(row, index) {
      if (row.timer) clearTimeout(row.timer)
      let inputValue = row.tempRetnCnt.toString()
      inputValue = inputValue.replace(/[^\d]/g, '')
      if (inputValue === '0') inputValue = ''
      row.tempRetnCnt = inputValue
      const tempRetnCnt = Number(row.tempRetnCnt) || 0
      const saleAmt = Number(row.saleAmt) || 0
      const salePric = Number(row.salePric) || 0
      row.diffAmount = saleAmt - (tempRetnCnt * salePric)
      row.timer = setTimeout(() => {
        this.lockRowAfterTimer(row, index)
      }, 2880)
      this.calculateRefundTotal()
      this.updateConfirmButtonState()
    },
    
    lockRowAfterTimer(row, index) {
      let tempRetnCnt = Number(row.tempRetnCnt) || 0
      const cnt = Number(row.cnt) || 0
      if (tempRetnCnt <= 0) {
        this.$message.error('待退数必须大于0')
        row.tempRetnCnt = ''
        row.editing = true
        return
      }
      if (!Number.isInteger(tempRetnCnt)) {
        this.$message.error('待退数必须为正整数')
        row.tempRetnCnt = Math.floor(tempRetnCnt)
        tempRetnCnt = Math.floor(tempRetnCnt)
      }
      if (tempRetnCnt > cnt) {
        this.$message.error(`待退数不能超过处方总数 ${cnt}`)
        row.tempRetnCnt = cnt
        tempRetnCnt = cnt
      }
      row.retnCnt = tempRetnCnt
      this.calculateDiffAmount(row)
      if (row.diffAmount < 0) {
        this.$message.warning(`药品 ${row.drugName} 的待退金额差异为负数，请检查输入`)
      }
      row.editing = false
      if (row.timer) clearTimeout(row.timer)
      row.timer = null
      this.calculateRefundTotal()
      this.updateConfirmButtonState()
    },
    
    calculateRefundTotal() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.refundTotalAmount = 0
        return 0
      }
      const total = this.rightTableData.reduce((sum, row) => {
        const salePric = Number(row.salePric) || 0
        const retnCnt = Number(row.retnCnt) || 0
        return sum + retnCnt * salePric
      }, 0)
      this.refundTotalAmount = total
      return total
    },
    
    editItem(row, index) {
      row.editing = true
      row.tempRetnCnt = row.retnCnt || ''
    },
    
    removeItem(index) {
      if (this.rightTableData[index].timer) clearTimeout(this.rightTableData[index].timer)
      this.rightTableData.splice(index, 1)
      this.calculateRefundTotal()
      this.updateConfirmButtonState()
    },
    
    updateConfirmButtonState() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.isConfirmButtonEnabled = false
        this.hasUncollectedTraceCode = false
        return
      }
      const hasValidRefund = this.rightTableData.some(item => Number(item.retnCnt) > 0)
      const hasEditingRow = this.rightTableData.some(item => item.editing === true)
      const hasNegativeDiff = this.rightTableData.some(item => Number(item.diffAmount) < 0)
      // 检查是否有必须录入追溯码但未完成的药品
      this.hasUncollectedTraceCode = this.rightTableData.some(item => {
        if (item.isBar === 1) {
          return !item.selectedTraceCodes || item.selectedTraceCodes.length === 0
        }
        return false
      })
      this.isConfirmButtonEnabled = hasValidRefund && !hasEditingRow && !hasNegativeDiff && !this.hasUncollectedTraceCode
    },
    
    // ===================== 确认退药 =====================
    async handleBatchRefund() {
      try {
        this.loading = true
        const validRefundItems = this.rightTableData.filter(item => Number(item.retnCnt) > 0)
        if (validRefundItems.length === 0) {
          this.$message.warning('请至少设置一条有效的待退数量')
          return
        }
        // 检查追溯码
        const uncollected = validRefundItems.filter(item => item.isBar === 1 && (!item.selectedTraceCodes || item.selectedTraceCodes.length === 0))
        if (uncollected.length > 0) {
          this.$message.error('存在必须录入追溯码的药品未完成选择')
          return
        }
        // 构建参数
        const params = {
          id: this.addForm.id,
          list: validRefundItems.map(item => {
            let tracCodeJson = ''
            if (item.isBar === 1 && item.selectedTraceDetails && item.selectedTraceDetails.length > 0) {
              tracCodeJson = JSON.stringify(item.selectedTraceDetails)   // selectedTraceDetails 已包含 manuLotnum
            }
            return {
              detailId: item.detailId || item.id,
              retnCnt: Number(item.retnCnt) || 0,
              tracCodeJson: tracCodeJson
            }
          })
        }
        // 打开进度对话框
        this.traceCodeUploadDialog = true
        this.traceCodeUploadStep = 0
        this.traceCodeUploadDetails = []
        this.traceCodeHasError = false
        this.showRetryButton = false
        this.uploadRetryCount = 0
        this.msfxUploading = false
        this.msfxUploadError = ''
        this.msfxUploadSuccess = true

        // 步骤1：检查追溯码
        await this.checkTraceCodeUploadStep1(validRefundItems)
        // 步骤2：接入码上放心
        await this.checkTraceCodeUploadStep2()
        // 步骤3：上传追溯码
        const uploadResult = await this.checkTraceCodeUploadStep3(validRefundItems);
        // 注意：即使 uploadResult.success 为 false，流程也会继续
        
        // 步骤4：完成上传（固定步骤索引）
        this.traceCodeUploadStep = 3;
        if (uploadResult.success && !uploadResult.skip) {
          this.addTraceCodeUploadDetail('追溯码退药已上传至码上放心平台。', 'success');
          this.traceCodeUploadSteps[3].description = '追溯码退药已上传至码上放心平台。';
          this.msfxUploadSuccess = true;
        } else if (!uploadResult.success) {
          this.addTraceCodeUploadDetail('追溯码上传失败，但仍可继续退药流程', 'warning');
          this.traceCodeUploadSteps[3].description = '追溯码上传失败';
          this.msfxUploadSuccess = false;
        } else {
          this.addTraceCodeUploadDetail('无追溯码需要上传，跳过此步骤', 'info');
          this.traceCodeUploadSteps[3].description = '无追溯码需要上传';
        }
        
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // 步骤5：完成退药
        await this.checkTraceCodeUploadStep5(params);
      } catch (error) {
        console.error('退药流程异常:', error)
        this.addTraceCodeUploadDetail('退药流程异常: ' + error.message, 'error')
        this.traceCodeHasError = true
        this.showRetryButton = true
      } finally {
        this.loading = false
      }
    },
    
    // ===================== 步骤方法 =====================
    async checkTraceCodeUploadStep1(validRefundItems) {
      this.traceCodeUploadStep = 0
      this.traceCodeUploadSteps[0].description = '正在检查是否有药品需要录入追溯码...'
      this.addTraceCodeUploadDetail('正在检查是否有药品需要录入追溯码...', 'info')
      const mandatoryTraceItems = validRefundItems.filter(item => item.isBar === 1)
      if (mandatoryTraceItems.length === 0) {
        this.addTraceCodeUploadDetail('没有需要录入追溯码的药品，跳过后续步骤', 'warning')
        this.traceCodeUploadSteps[0].description = '没有需要录入追溯码的药品'
        this.traceCodeUploadStep = 2
        return
      }
      this.addTraceCodeUploadDetail(`发现 ${mandatoryTraceItems.length} 个药品需要录入追溯码`, 'success')
      this.traceCodeUploadSteps[0].description = `发现 ${mandatoryTraceItems.length} 个药品需要录入追溯码`
      await new Promise(resolve => setTimeout(resolve, 1000))
    },
    
    async checkTraceCodeUploadStep2() {
      this.traceCodeUploadStep = 1
      this.traceCodeUploadSteps[1].description = '正在接入码上放心平台接口...'
      this.addTraceCodeUploadDetail('正在接入码上放心平台接口...', 'info')
      await new Promise(resolve => setTimeout(resolve, 1500))
      this.addTraceCodeUploadDetail('码上放心平台接口接入成功', 'success')
      this.traceCodeUploadSteps[1].description = '码上放心平台接口接入成功'
      await new Promise(resolve => setTimeout(resolve, 1000))
    },
    
    // 步骤3：上传追溯码到码上放心平台
    async checkTraceCodeUploadStep3(validRefundItems) {
      this.traceCodeUploadStep = 2;
      this.traceCodeUploadSteps[2].description = '正在上传退药明细追溯码数据...';
      this.addTraceCodeUploadDetail('正在上传退药明细追溯码数据...', 'info');
    
      // 获取需要上传追溯码的药品
      const mandatoryTraceItems = validRefundItems.filter(item => 
        item.isBar === 1 && item.selectedTraceDetails && item.selectedTraceDetails.length > 0
      );
    
      if (mandatoryTraceItems.length === 0) {
        this.addTraceCodeUploadDetail('没有需要上传追溯码的药品，跳过此步骤', 'warning');
        this.traceCodeUploadSteps[2].description = '没有需要上传追溯码的药品';
        this.traceCodeUploadStep = 3;
        return { success: true, skip: true };
      }
    
      // 收集所有追溯码
      const allTraceCodes = [];
      mandatoryTraceItems.forEach(item => {
        item.selectedTraceDetails.forEach(detail => {
          if (detail.barcode) allTraceCodes.push(detail.barcode);
        });
      });
    
      if (allTraceCodes.length === 0) {
        this.addTraceCodeUploadDetail('没有有效的追溯码，跳过此步骤', 'warning');
        this.traceCodeUploadSteps[2].description = '没有有效的追溯码';
        this.traceCodeUploadStep = 3;
        return { success: true, skip: true };
      }
    
      // 检查追溯码数量限制
      if (allTraceCodes.length > 10000) {
        this.addTraceCodeUploadDetail(`追溯码数量 ${allTraceCodes.length} 超过10000个，请分批上传`, 'error');
        this.traceCodeUploadSteps[2].description = '追溯码数量超过限制';
        this.msfxUploadError = '追溯码数量超过10000个限制';
        this.addTraceCodeUploadDetail(`错误信息: ${this.msfxUploadError}`, 'error');
        this.traceCodeHasError = true;
        this.msfxUploadSuccess = false;
        // 即使数量超限，仍然允许继续退药流程
        return { success: true, skip: false };
      }
    
      // 检查重复追溯码
      const uniqueTraceCodes = [...new Set(allTraceCodes)];
      if (uniqueTraceCodes.length !== allTraceCodes.length) {
        this.addTraceCodeUploadDetail('存在重复的追溯码，请检查', 'error');
        this.traceCodeUploadSteps[2].description = '存在重复的追溯码';
        this.msfxUploadError = '存在重复的追溯码';
        this.addTraceCodeUploadDetail(`错误信息: ${this.msfxUploadError}`, 'error');
        this.traceCodeHasError = true;
        this.msfxUploadSuccess = false;
        // 即使重复，仍然允许继续退药流程
        return { success: true, skip: false };
      }
    
      // 调用上传接口
      const uploadResult = await this.uploadTraceCodesToMsfx(uniqueTraceCodes, validRefundItems);
    
      if (uploadResult.success) {
        this.addTraceCodeUploadDetail(`已成功上传 ${uniqueTraceCodes.length} 条追溯码记录`, 'success');
        this.traceCodeUploadSteps[2].description = `已成功上传 ${uniqueTraceCodes.length} 条追溯码记录`;
        this.msfxUploadSuccess = true;
      } else {
        // 上传失败：标记错误，但允许继续退药流程
        this.addTraceCodeUploadDetail(`上传失败: ${uploadResult.message}`, 'error');
        this.traceCodeUploadSteps[2].description = '上传失败';
        this.traceCodeHasError = true;
        this.msfxUploadSuccess = false;
        // 不阻断流程，继续执行步骤5
      }
    
      return { success: true, skip: false };
    },
    
    async uploadTraceCodesToMsfx(traceCodes, validRefundItems) {
      try {
        this.addTraceCodeUploadDetail(`准备上传 ${traceCodes.length} 个追溯码...`, 'info')
        const bizNum = this.prescriptionDetail.refundList?.[0]?.rxId || ''
        if (!bizNum) {
          this.addTraceCodeUploadDetail('获取业务单据编号失败', 'error')
          return { success: false, message: '获取业务单据编号失败' }
        }
        let msfxEntId = ''
        try {
          const systemListResponse = await getSystemList()
          if (systemListResponse && systemListResponse.code === 200 && systemListResponse.data) {
            const msfxParam = systemListResponse.data.find(param => 
              param.name && param.name.includes('码上放心') && param.param === 'mafx_refentid'
            )
            if (msfxParam && msfxParam.value) {
              msfxEntId = msfxParam.value.trim()
              this.addTraceCodeUploadDetail(`获取到码上放心entid: ${msfxEntId}`, 'success')
            } else {
              this.addTraceCodeUploadDetail('未找到码上放心企业ID参数', 'warning')
            }
          }
        } catch (error) {
          console.error('获取系统参数失败:', error)
          this.addTraceCodeUploadDetail('获取系统参数失败: ' + error.message, 'warning')
        }
        if (!msfxEntId) {
          this.addTraceCodeUploadDetail('无法获取码上放心entid，上传终止', 'error')
          return { success: false, message: '无法获取码上放心entid' }
        }
        const params = {
          billType: 103,
          bizNum: bizNum,
          fromUserId: msfxEntId,
          physicType: 3,
          toUserId: msfxEntId,
          traceCodes: traceCodes.join(',')
        }
        this.addTraceCodeUploadDetail('正在调用msfxUploadInoutBill接口...', 'info')
        let response = await msfxUploadInoutBill(params)
        if (response.code !== 200) {
          this.addTraceCodeUploadDetail(`上传失败: ${response.message || '未知错误'}`, 'error')
          this.msfxUploadError = response.message || '上传失败'
          return { success: false, message: response.message || '上传失败' }
        }
        this.addTraceCodeUploadDetail('追溯码上传成功', 'success')
        return { success: true, message: '上传成功' }
      } catch (error) {
        console.error('上传追溯码失败:', error)
        this.msfxUploadError = error.message || '上传失败'
        return { success: false, message: error.message || '上传失败' }
      }
    },
    
    // 步骤5：完成退药
    async checkTraceCodeUploadStep5(params) {
      this.traceCodeUploadStep = 4;
      this.traceCodeUploadSteps[4].description = '正在执行退药操作...';
      this.addTraceCodeUploadDetail('正在执行退药操作...', 'info');
    
      try {
        this.addTraceCodeUploadDetail('开始调用退药接口...', 'info');
        const res = await tySave(params);
    
        if (res.code === 200) {
          this.addTraceCodeUploadDetail('退药成功', 'success');
          this.traceCodeUploadSteps[4].description = '退药成功';
    
          if (this.msfxUploadSuccess && !this.traceCodeHasError) {
            // 全部成功，自动关闭
            this.autoCloseTimer = setTimeout(() => {
              this.closeTraceCodeUploadDialog();
              this.$message.success('退药成功');
              this.loadData();
            }, 1000);
          } else {
            // 上传失败但退药成功，显示“我已知晓”按钮
            this.addTraceCodeUploadDetail('退药成功，但追溯码上传存在问题，请检查', 'warning');
            this.showRetryButton = true;
            // 不自动关闭，等待用户点击“我已知晓”
          }
          return true;
        } else {
          this.addTraceCodeUploadDetail('退药失败: ' + (res.message || '未知错误'), 'error');
          this.traceCodeUploadSteps[4].description = '退药失败';
          this.showRetryButton = true;
          this.traceCodeHasError = true;
          return false;
        }
      } catch (error) {
        this.addTraceCodeUploadDetail('退药失败: ' + error.message, 'error');
        this.traceCodeUploadSteps[4].description = '退药失败';
        this.showRetryButton = true;
        this.traceCodeHasError = true;
        return false;
      }
    },
    
    // ===================== 进度条辅助方法 =====================
    addTraceCodeUploadDetail(message, type = 'info') {
      const now = new Date()
      const time = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`
      this.traceCodeUploadDetails.push({ message, type, time })
      this.$nextTick(() => {
        const container = this.$refs.uploadDetailsContainer
        if (container) container.scrollTop = container.scrollHeight
      })
    },
    
    getStepStatus(index) {
      if (this.traceCodeHasError && index === this.traceCodeUploadStep) return 'error'
      if (index < this.traceCodeUploadStep) return 'finish'
      if (index === this.traceCodeUploadStep) return 'process'
      return 'wait'
    },
    
    getDetailIcon(type) {
      switch (type) {
        case 'success': return 'el-icon-success'
        case 'error': return 'el-icon-error'
        case 'warning': return 'el-icon-warning'
        default: return 'el-icon-info'
      }
    },
    
    handleUploadCancel() {
      this.$confirm('确定要取消上传吗？取消后需要重新开始。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.traceCodeUploadDialog = false
        this.resetTraceCodeUpload()
      })
    },
    
    // 关闭追溯码上传进度对话框
    closeTraceCodeUploadDialog() {
      this.traceCodeUploadDialog = false;
      this.refundDialogVisible = false; // 关闭退药模态框
      this.resetTraceCodeUpload();
      this.loadData(); // 刷新列表
      this.$message.success('数据已刷新');
    },
    
    resetTraceCodeUpload() {
      this.traceCodeUploadStep = 0
      this.traceCodeUploadSteps = [
        { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...' },
        { title: '接入码上放心', description: '正在接入码上放心平台接口...' },
        { title: '上传追溯码', description: '正在上传退药明细追溯码数据...' },
        { title: '完成上传', description: '追溯码退药已上传至码上放心平台。' },
        { title: '完成退药', description: '已完成退药。' }
      ]
      this.traceCodeUploadDetails = []
      this.traceCodeHasError = false
      this.showRetryButton = false
      this.uploadRetryCount = 0
      this.msfxUploading = false
      this.msfxUploadError = ''
      this.msfxUploadSuccess = true
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
    },
    
    // ===================== 保留的空方法（避免报错） =====================
    async handleScanTraceCode() {
      // 不再使用，保留空方法
    },
    completeTraceCode() {
      // 不再使用，保留空方法
    },
    addTraceCodeRow() {
      // 不再使用，保留空方法
    },
    removeScannedMedicine(index) {
      // 不再使用
    },
    clearAllScannedMedicines() {
      // 不再使用
    },
    handleTraceCodeClose() {
      // 不再使用
    },
    handleTraceCodeBeforeClose(done) {
      done()
    },
    scannedRowClassName({ row }) {
      return ''
    },
    buildTraceCodeArray(traceCodeString, pacCnt) {
      return ''
    },
    extractNumberFromString(str) {
      return 1
    },
    addToScannedList(medicineData) {
      // 不再使用
    },
    getMsfxEntId() {
      return ''
    },
    retryMsfxUpload() {
      // 不再使用
    }
  }
}
</script>

<style lang="less" scoped>
.disposal-statistics-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  overflow: hidden;
  
  // 头部区域
  .header-section {
    padding: 16px 20px;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #00405e;
      margin-bottom: 4px;
    }
    
    .sub-title {
      font-size: 14px;
      color: #666;
    }
  }
  
  // 筛选区域
  .filter-section {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-top: 8px;
    .filter-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .filter-left {
        display: flex;
        align-items: center;
        gap: 20px;
        
        .filter-item {
          display: flex;
          align-items: center;
          
          .filter-label {
            font-size: 12px;
            color: #606266;
            margin-right: 8px;
            white-space: nowrap;
          }
          
          .state-dropdown-btn {
            background: linear-gradient(135deg, #409EFF, #66b1ff);
            border: none;
            border-radius: 4px;
            padding: 7px 12px;
            font-size: 12px;
            min-width: 80px;
          }
        }
      }
      
      .filter-right {
        display: flex;
        gap: 8px;
      }
    }
  }
  
  // 表格区域
  .table-section {
    flex: 1;
    margin-top: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    
    .table-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      
      .el-table {
        flex: 1;
        overflow: auto;
        
        // 状态为3的行样式
        ::v-deep .warning-row {
          background-color: #fdf6ec !important;
        }
        
        .action-buttons {
          display: flex;
          justify-content: space-around;
          align-items: center;
          
          .el-button {
            padding: 5px 8px;
            font-size: 12px;
          }
        }
        
        // 性别显示样式
        .gender-display {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          
          .male-icon {
            color: #409EFF;
            font-size: 14px;
          }
          
          .female-icon {
            color: #F56C6C;
            font-size: 14px;
          }
          
          .male-text {
            color: #409EFF;
            font-weight: 500;
          }
          
          .female-text {
            color: #F56C6C;
            font-weight: 500;
          }
        }
        
        // 病人姓名字段样式
        .patient-name-link {
          color: #409EFF;
          text-decoration: none;
          font-weight: bold;
          transition: color 0.3s;
          
          &:hover {
            color: #1a6be0;
            text-decoration: underline;
          }
        }
      }
      
      .pagination-container {
        padding: 16px 0;
        background-color: #fff;
        border-top: 1px solid #e6e6e6;
        
        &.left-pagination {
          display: flex;
          justify-content: flex-start;
          
          .el-pagination {
            margin: 0;
          }
        }
      }
    }
  }
}

// 处方药品明细表格文字大小
::v-deep .detail-table {
  font-size: 12px !important;
  
  .el-table__header th {
    font-size: 12px !important;
  }
  
  .el-table__body td {
    font-size: 12px !important;
  }
}

// 退药明细表格文字大小
::v-deep .refund-detail-table {
  font-size: 12px !important;
  
  .el-table__header th {
    font-size: 12px !important;
  }
  
  .el-table__body td {
    font-size: 12px !important;
  }
  
  .retn-cnt-input {
    .el-input__inner {
      font-size: 12px !important;
      height: 28px;
      line-height: 28px;
      text-align: center;
    }
  }
  
  .action-column {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .diff-amount {
      font-size: 12px;
      color: #67C23A;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 80px;
      display: inline-block;
      
      &.negative {
        color: #F56C6C;
      }
      
      &.positive {
        color: #67C23A;
      }
    }
    
    .el-button {
      font-size: 12px;
      padding: 0 2px;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    gap: 16px;
    
    .filter-left {
      flex-wrap: wrap;
    }
    
    .filter-right {
      width: 100%;
      justify-content: center;
    }
  }
  
  .pagination-container {
    &.left-pagination {
      justify-content: center !important;
    }
  }
}
</style>

<style lang="less">
	// 自定义模态框样式
	.custom-dialog {
	  border-radius: 8px !important;
	  overflow: hidden;
	  
	  .el-dialog__header {
	    background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%) !important;
	    padding: 15px 20px;
	    border-radius: 8px 8px 0 0;
	    
	    .el-dialog__title {
	      color: white;
	      font-weight: 600;
	      font-size: 16px;
	    }
	    .el-dialog__headerbtn {
	      .el-dialog__close {
	        color: white;
	        font-size: 18px;
	        
	        &:hover {
	          color: #f0f0f0;
	        }
	      }
	    }
	  }
	  
	  .el-dialog__body {
	    // padding: 20px 20px 100px 20px; /* 底部留出更多空间给固定操作区域 */
	    // max-height: 70vh;
	    overflow-y: auto;
	  }
	  
	  .el-dialog__footer {
	    border-top: none;
	  }
	  
	  .detail-content{
		
		.detail-table-container{
			.table-title{
				padding: 12px 0;
				color: #5b5b5b;
				font-weight: bold;
				font-size: 16px;
			}
		}
	  }
	}
	
	// 退药模态框样式
	.refund-dialog {
	  .el-dialog {
	    width: 80% !important;
	    max-width: 1200px;
	  }
	  
	  .refund-content {
	    .refund-info {
	      margin-bottom: 20px;
	
	      .title-with-select {
	        display: flex;
	        justify-content: space-between;
	        align-items: center;
	        
	        .refund-reason-select {
	          display: flex;
	          align-items: center;
	          
	          .reason-label {
	            font-size: 12px;
	            color: #606266;
	            margin-right: 8px;
	            white-space: nowrap;
	          }
	          
	          .reason-select {
	            width: 200px;
	            
	            .el-input__inner {
	              height: 28px;
	              line-height: 28px;
	            }
	          }
	          
	          .remark-textarea {
	            width: 150px;
	            
	            .el-textarea__inner {
	              resize: none;
	              height: 28px;
	              line-height: 28px;
	            }
	          }
	        }
	      }
	
	      .gender-display {
	        display: flex;
	        align-items: center;
	        gap: 4px;
	
	        .male-icon {
	          color: #409EFF;
	        }
	
	        .female-icon {
	          color: #F56C6C;
	        }
	        
	        .male-text {
	          color: #409EFF;
	        }
	        
	        .female-text {
	          color: #F56C6C;
	        }
	      }
	    }
	    
	    // 处方退药明细表区域
	    .refund-detail-container {
	      margin-bottom: 20px;
	      border: 1px solid #ebeef5;
	      border-radius: 4px;
	      overflow: hidden;
	      
	      .refund-detail-content {
	        display: flex;
	        height: 400px;
	        
	        .left-drug-list {
	          width: 18%; /* 左侧宽度18% */
	          border-right: 1px solid #ebeef5;
	          display: flex;
	          flex-direction: column;
	          
	          .drug-list-header {
	            padding: 12px 16px;
	            border-bottom: 1px solid #ebeef5;
	            display: flex;
	            justify-content: space-between;
	            align-items: center;
	            
	            .drug-list-title {
	              font-size: 14px;
	              font-weight: 600;
	              color: #333;
	            }
	            
	            .refund-all-btn {
	              padding: 4px 8px;
	              font-size: 12px;
	            }
	          }
	          
	          .drug-list-content {
	            flex: 1;
	            overflow-y: auto;
	            max-height: 320px; /* 设置最大高度，确保滚动 */
	            scrollbar-width: thin;
	            scrollbar-color: #c1c1c1 #f5f5f5;
	            
	            &::-webkit-scrollbar {
	              width: 6px;
	            }
	            
	            &::-webkit-scrollbar-track {
	              background: #f5f5f5;
	              border-radius: 3px;
	            }
	            
	            &::-webkit-scrollbar-thumb {
	              background: #c1c1c1;
	              border-radius: 3px;
	            }
	            
	            &::-webkit-scrollbar-thumb:hover {
	              background: #a8a8a8;
	            }
	            
	            .drug-list-item {
	              padding: 12px 16px;
	              border-bottom: 1px solid #f0f0f0;
	              display: flex;
	              align-items: center;
	              cursor: pointer;
	              transition: background-color 0.3s;
	              
	              &:hover {
	                background-color: #f5f7fa;
	              }
	              
	              &.selected {
	                background-color: #f0f9ff;
	                border-left: 3px solid #409EFF;
	              }
	              
	              .drug-avatar {
	                width: 36px;
	                height: 36px;
	                border-radius: 50%;
	                background: linear-gradient(135deg, #409EFF, #66b1ff);
	                color: white;
	                display: flex;
	                align-items: center;
	                justify-content: center;
	                font-size: 16px;
	                font-weight: bold;
	                margin-right: 12px;
	                flex-shrink: 0;
	              }
	              
	              .drug-info {
	                flex: 1;
	                overflow: hidden;
	                
	                .drug-name {
	                  font-size: 13px;
	                  font-weight: 500;
	                  color: #333;
	                  margin-bottom: 2px;
	                  white-space: nowrap;
	                  overflow: hidden;
	                  text-overflow: ellipsis;
	                }
	                
	                .drug-spec {
	                  font-size: 11px;
	                  color: #666;
	                  margin-bottom: 4px;
	                  white-space: nowrap;
	                  overflow: hidden;
	                  text-overflow: ellipsis;
	                }
	              }
	              
	              .drug-right-info {
	                display: flex;
	                flex-direction: column;
	                align-items: flex-end;
	                margin-left: 8px;
	                
	                .drug-cnt {
	                  font-size: 12px;
	                  color: #409EFF;
	                  font-weight: 500;
	                  margin-bottom: 2px;
	                  white-space: nowrap;
	                }
	                
	                .drug-amount {
	                  font-size: 12px;
	                  color: #F56C6C;
	                  font-weight: 500;
	                  white-space: nowrap;
	                }
	              }
	            }
	          }
	        }
	        
	        .right-refund-table {
	          width: 82%; /* 右侧宽度82% */
	          display: flex;
	          flex-direction: column;
	          
	          .table-header {
	            padding: 12px 16px;
	            border-bottom: 1px solid #ebeef5;
	            font-size: 14px;
	            font-weight: 600;
	            color: #333;
	          }
	          
	          .table-container {
	            flex: 1;
	            overflow: auto;
	            
	            .refund-detail-table {
	              height: 100%;
	              
	              .el-table__body-wrapper {
	                max-height: 350px;
	                overflow-y: auto;
	              }
	            }
	          }
	        }
	      }
	    }
	    
	    .no-data {
	      padding: 40px 0;
	      text-align: center;
	      color: #909399;
	    }
	  }
	  
	  // 底部固定操作区域
	  .refund-footer-fixed {
	    position: absolute;
	    bottom: 0;
	    left: 0;
	    right: 0;
	    background: white;
	    padding: 15px 20px;
	    border-top: 1px solid #ebeef5;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    z-index: 1000;
	
	    .footer-left-info {
	      flex: 1;
	      
	      .info-row {
	        display: flex;
	        align-items: center;
	        flex-wrap: wrap;
	        gap: 20px;
	        
	        .info-item {
	          display: flex;
	          align-items: center;
	          
	          .info-label {
	            font-size: 14px;
	            color: #606266;
				font-weight: 600;
	            white-space: nowrap;
	          }
	          
	          .info-value {
	            font-size: 14px;
	            font-weight: 600;
	            color: #00557f;
	            margin-left: 4px;
	          }
			  .info-value-money{
				font-size: 14px;
				font-weight: 600;
				color: #ac0000;
				margin-left: 4px;
			  }
	        }
	      }
	    }
	
	    .refund-actions {
	      display: flex;
	      gap: 8px;
	    }
	  }
	}
	
	// 响应式设计
	@media (max-width: 1200px) {
	  .disposal-statistics-container {
	    .detail-container {
	      flex-direction: column;
	      height: auto;
	      
	      .detail-left {
	        width: 100%;
	        margin-bottom: 20px;
	      }
	    }
	    
	    .refund-dialog {
	      .el-dialog {
	        width: 90% !important;
	      }
	      
	      .refund-footer-fixed {
	        flex-direction: column;
	        align-items: flex-start;
	        gap: 10px;
	        
	        .footer-left-info {
	          .info-row {
	            gap: 10px;
	          }
	        }
	      }
	    }
	  }
	}
</style>

<style lang="less" scoped>
	/* 追溯码穿梭框样式调整 */
	/deep/ .trace-code-transfer-dialog .el-transfer {
	  display: flex;
	  justify-content: center;
	}
	/deep/ .trace-code-transfer-dialog .el-transfer-panel {
	  width: 620px; /* 适当加宽，可根据实际需求调整 */
	}
	/deep/ .trace-code-transfer-dialog .el-transfer-panel__body {
	  font-size: 12px;
	}
	/deep/ .trace-code-transfer-dialog .el-transfer-panel__item {
	  font-size: 12px;
	}
	/deep/ .trace-code-transfer-dialog .el-transfer-panel__item .el-checkbox__label {
	  font-size: 12px;
	}
	/deep/ .trace-code-transfer-dialog .el-transfer-panel__header {
	  font-size: 13px; /* 标题稍大一点，可自定义 */
	}
/* 追溯码采集对话框样式 */
.trace-code-collect-dialog {
  .trace-code-dialog-content {
    padding: 20px;
    max-height: 80vh;
    overflow: hidden;
    
    /* 重要提示样式 */
    .important-reminder {
      background: #f0f9ff;
      border: 1px solid #91d5ff;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 16px;
      
      .reminder-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        color: #1890ff;
        font-weight: 500;
        
        i {
          margin-right: 8px;
        }
      }
      
      .reminder-content p {
        margin: 4px 0;
        color: #1890ff;
        font-size: 13px;
        line-height: 1.5;
      }
    }
    
    /* 扫描输入区域 */
    .scan-input-area {
      margin-bottom: 16px;
      
      .trace-code-input {
        margin-bottom: 8px;
        
        .el-input__inner {
          height: 36px;
          font-size: 14px;
        }
      }
      
      .input-tips {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        font-size: 12px;
        color: #909399;
        margin-top: 6px;
        
        span {
          display: flex;
          align-items: center;
          
          i {
            margin-right: 4px;
            font-size: 12px;
          }
        }
      }
    }
    
    /* 验证结果样式 */
    .validation-result {
      margin-bottom: 20px;
      
      ::v-deep .el-card {
        border: 1px solid #e6e6e6;
        
        .el-card__header {
          padding: 12px 20px;
          background-color: #f5f7fa;
          border-bottom: 1px solid #e6e6e6;
        }
        
        .validation-result-content {
          .result-row {
            display: flex;
            margin-bottom: 8px;
            min-height: 24px;
            align-items: center;
            
            &:last-child {
              margin-bottom: 0;
            }
            
            .result-label {
              flex: 0 0 80px;
              font-size: 12px;
              color: #606266;
              text-align: right;
              padding-right: 8px;
              font-weight: 500;
              white-space: nowrap;
            }
            
            .result-value {
              flex: 1;
              font-size: 12px;
              color: #303133;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
    
    /* 已扫描的药品信息区域 */
    .scanned-medicine-list-section {
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      background-color: #fff;
      
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #e6e6e6;
        background-color: #fafafa;
        
        h4 {
          margin: 0;
          color: #303133;
          font-size: 14px;
          font-weight: 600;
        }
        
        .el-button {
          padding: 4px 8px;
          font-size: 12px;
          height: auto;
        }
      }
      
      /* 表格容器 */
      .table-wrapper {
        overflow: hidden;
        
        .scanned-medicine-table {
          height: 100% !important;
          
          ::v-deep .el-table {
            height: 100% !important;
            
            .el-table__body-wrapper {
              overflow-y: auto;
            }
            
            .el-table__fixed-body-wrapper {
              height: calc(100% - 40px) !important;
            }
            
            .el-table__body,
            .el-table__header-wrapper {
              width: 100% !important;
            }
            
            th, td {
              padding: 6px 0;
            }
            
            .cell {
              padding: 0 8px;
              line-height: 24px;
              font-size: 12px;
            }
            
            /* 表格行悬停效果 */
            .el-table__row:hover {
              td {
                background-color: #f5f7fa !important;
              }
            }
            
            /* 重复追溯码行样式 */
            .duplicate-row {
              td {
                background-color: #fff2f0 !important;
              
                &:hover {
                  background-color: #ffccc7 !important;
                }
              }
            }
          }
          
          /* 省略号文本 */
          .ellipsis-text {
            display: inline-block;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: default;
          }
          
          /* 重复追溯码样式 */
          .duplicate-code {
            color: #F56C6C;
            font-weight: 500;
            padding: 2px 6px;
            background-color: #fff2f0;
            border-radius: 2px;
          }
        }
      }
      
      .scanned-summary {
        padding: 8px 16px;
        text-align: right;
        font-size: 12px;
        color: #606266;
        border-top: 1px solid #f0f0f0;
        background-color: #fafafa;
      }
    }
    
    /* 空状态样式 */
    .empty-scanned-list {
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      padding: 40px 20px;
      text-align: center;
      background-color: #fafafa;
      margin-top: 20px;
      
      .empty-content {
        color: #909399;
        font-size: 13px;
        
        i {
          font-size: 40px;
          margin-bottom: 12px;
        }
      }
    }
  }
  
  /* 对话框底部按钮样式 */
  .trace-code-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px;
    border-top: 1px solid #e6e6e6;
    background-color: #fff;
    
    .el-button {
      min-width: 80px;
    }
  }
}

/* 自定义滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 对话框样式优化 */
.trace-code-collect-dialog {
  ::v-deep .el-dialog {
    width: 1200px !important;
    max-width: 90vw;
    
    .el-dialog__body {
      max-height: 70vh;
      overflow-y: auto;
      padding: 0;
    }
  }
}
</style>

<style lang="less" scoped>
/* 添加追溯码按钮的tooltip样式 */
::v-deep .add-tracecode-tooltip {
  max-width: 200px;
}

/* 步骤进度条样式 */
.trace-code-upload-dialog {
  .upload-progress-dialog {
    .upload-steps {
      margin-bottom: 20px;
    }
    
    .upload-details {
      margin-top: 20px;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      padding: 12px;
      
      .details-title {
        font-weight: 500;
        margin-bottom: 8px;
        color: #303133;
      }
      
      .details-content {
        .detail-item {
          padding: 6px 0;
          border-bottom: 1px solid #f0f0f0;
          display: flex;
          align-items: center;
          font-size: 13px;
          
          &:last-child {
            border-bottom: none;
          }
          
          i {
            margin-right: 8px;
            font-size: 16px;
          }
          
          .detail-time {
            margin-left: auto;
            color: #909399;
            font-size: 12px;
          }
          
          &.success {
            color: #67C23A;
            
            i {
              color: #67C23A;
            }
          }
          
          &.error {
            color: #F56C6C;
            
            i {
              color: #F56C6C;
            }
          }
          
          &.warning {
            color: #E6A23C;
            
            i {
              color: #E6A23C;
            }
          }
          
          &.info {
            color: #909399;
            
            i {
              color: #909399;
            }
          }
        }
      }
    }
  }
}
</style>